import { createSentryInit } from '@piaas/piaas-ui-toolkit/sentry';

export const initSentry = createSentryInit(() => ({
  dsn: import.meta.env.VITE_SENTRY_UI_DSN,
  environment: window.PORTAL_ENV ?? import.meta.env.VITE_ENV,
  tracesSampleRate:
    window.PORTAL_SENTRY_TRACES_SAMPLE_RATE ?? import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  tracePropagationTargets:
    window.PORTAL_SENTRY_TRACE_PROPAGATION_TARGETS ??
    import.meta.env.VITE_SENTRY_TRACE_PROPAGATION_TARGETS,
}));
